import { useEffect, useState } from 'react';

export default function useReadableLocation(location) {
  const [address, setAddress] = useState("");

  useEffect(() => {
    const fetchAddress = async () => {
      if (!location || !location.lat || !location.lng) {
        setAddress("");
        return;
      }

      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.lat},${location.lng}&key=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.status === 'OK' && data.results.length > 0) {
          setAddress(data.results[0].formatted_address);
        }
      } catch (error) {
        return;
      }
    };

    fetchAddress();
  }, [location]);

  return address;
}